module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQAQMAAADVx0KsAAAABlBMVEXOESb///9W4q7JAAAAF0lEQVR4AWMgBYyCUfAfCXzAzxvljfIAKnwDvwOMMe0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/mc.png
// module id = +raE
// module chunks = 0